document.addEventListener("DOMContentLoaded", function () {
  const preloader = document.getElementById("preloader");
  const preloaderImgOverlay = document.querySelector(".preloader-img-overlay");

  // Check if carousel items exist on the page
  const carouselItems = document.querySelectorAll(
    ".home-main-swiper-parallax-container"
  );

  // If carousel items don't exist, immediately remove the preloader
  if (carouselItems.length === 0 && preloader) {
    console.log(
      "No carousel items found on page, removing preloader immediately"
    );
    preloader.style.opacity = "0";
    setTimeout(() => {
      preloader.style.display = "none";
    }, 500);
    return; // Exit early, no need for event listeners or fallback
  }

  // Listen for our custom event
  document.addEventListener("firstSwiperImageLoaded", function () {
    if (preloader) {
      // Fade out preloader with smooth transition
      preloader.style.opacity = "0";
      setTimeout(() => {
        preloader.style.display = "none";
      }, 500); // Increased delay for smoother transition
    }
  });

  // Fallback in case something goes wrong or event isn't triggered
  setTimeout(() => {
    if (preloader && preloader.style.display !== "none") {
      console.log("Preloader fallback triggered after timeout");
      preloader.style.opacity = "0";
      setTimeout(() => {
        preloader.style.display = "none";
      }, 500);
    }
  }, 5000); // 5 second fallback
});
